import { ColumnDef } from './types';

export const columns: ColumnDef[] = [
  { key: 'gas_date', label: 'Gas Date' },
  { key: 'original_path_fingerprint', label: 'Path Fingerprint' },
  { key: 'path_is_valid', label: 'Path Valid' },
  { key: 'link_order', label: 'Link Order' },
  { key: 'r_point_name', label: 'Path Receipt Point Name' },
  { key: 'd_point_name', label: 'Path Delivery Point Name' },
  { key: 'delivered_dth', label: 'Delivered Volume' },
  { key: 'tsp_list', label: 'Path TSP List' },
  { key: 'contract_list', label: 'Path Contract List' },
  { key: 'nom_r_point_name', label: 'Nom Receipt Point Name' },
  { key: 'nom_d_point_name', label: 'Nom Delivery Point Name' },
  { key: 'nom_tsp_name', label: 'Nom TSP Name' },
  { key: 'nom_transport_external_id', label: 'Transport External ID' },
  { key: 'nom_transport_desk', label: 'Transport Desk' },
  { key: 'link_receipt_volume', label: 'Link Receipt Volume' },
  { key: 'link_delivery_volume', label: 'Link Delivery Volume' },
  { key: 'receipt_trade_type', label: 'Receipt Trade Type' },
  { key: 'delivery_trade_type', label: 'Delivery Trade Type' },
  { key: 'nom_receipt_volume', label: 'Nom Receipt Volume' },
  { key: 'nom_delivery_volume', label: 'Nom Delivery Volume' },
  { key: 'nom_fuel_loss', label: 'Nom Fuel Loss' },
  { key: 'receipt_interconnect_name', label: 'Receipt Interconnect Name' },
  { key: 'delivery_interconnect_name', label: 'Delivery Interconnect Name' },
  { key: 'path_id', label: 'Path ID' },
  { key: 'point_names', label: 'Path Point Names' },
  { key: 'nom_is_actual', label: 'Nom Is Actual' },
  { key: 'nom_is_cut', label: 'Nom Is Cut' },
];

export const defaultLimit = 200;

export const advancedToggleColumnKeys: ColumnDef['key'][] = [
  'gas_date',
  'original_path_fingerprint',
  'path_id',
  'point_names',
  'path_is_valid',
  'nom_is_actual',
  'nom_is_cut',
];

export const toTodayDate = () => new Date().toISOString().slice(0, 10);

export const uniqueNumbers = (values: number[]): number[] =>
  Array.from(new Set(values)).sort((a, b) => a - b);

export const formatCellValue = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'boolean') return value ? 'true' : 'false';
  if (typeof value === 'number') return Number.isFinite(value) ? `${value}` : '';
  return String(value);
};
